<template>
  <section>
    <div class="container">
      <page-title-component title="Thank you!" subtitle="Your vote has been registered." />
      <p>You can always change your vote by following the link in the e-mail and re-entering your choices, as long as the voting is open.</p>
      <br />
      <p>
        <strong>
          <router-link to="/competitionslist">
            <a>Back to competitions</a>
          </router-link>
        </strong>
      </p>
    </div>
  </section>
</template>

<script>
import PageTitleComponent from "./PageTitle.vue";

export default {
  name: "VoteConfirmed",
  components: {
    PageTitleComponent
  },
  props: {
    competitionId: String
  },
  data: function() {
    return {
      count: 0
    };
  }
};
</script>